// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"324":"b2bee068","694":"b7f869f9"}[chunkId] + ".chunk.js");